export const KEYBOARD_LAYOUT = {
  default: [
    "1 2 3 4 5 6 7 8 9 0",
    "q w e r t y u i o p",
    "a s d f g h j k l _",
    "{shift} z x c v b n m - {bksp}",
    "{numbers} @ {space} . {arrowleft} {arrowright}",
  ],
  shift: [
    "1 2 3 4 5 6 7 8 9 0",
    "Q W E R T Y U I O P",
    "A S D F G H J K L _",
    "{shift} Z X C V B N M - {bksp}",
    "{numbers} @ {space} . {arrowleft} {arrowright}",
  ],
  numbers: [
    "1 2 3 4 5 6 7 8 9 0",
    "! @ # $ % ^ & * ( )",
    "- _ = + [ ] { } / \\",
    "; : ' \" , . ? ~ {bksp}",
    "{abc} @ {space} . {arrowleft} {arrowright}",
  ],
};

export const KEYBOARD_DISPLAY = {
  "{bksp}": "⌫",
  "{shift}": "⇧",
  "{numbers}": "123",
  "{abc}": "ABC",
  "{space}": "space",
  "{arrowleft}": "←",
  "{arrowright}": "→",
  "{clear}": "✕",
};

export const KEYBOARD_BUTTON_THEME = [
  {
    class: "hg-key-accent",
    buttons: "{bksp} {numbers} {abc} {arrowleft} {arrowright}",
  },
  { class: "hg-key-space", buttons: "{space}" },
];

export const NUMPAD_LAYOUT = {
  default: ["1 2 3", "4 5 6", "7 8 9", "{bksp} 0 {clear}"],
};

export const NUMPAD_BUTTON_THEME = [
  {
    class: "hg-key-accent",
    buttons: "{bksp} {arrowleft} {arrowright} {clear}",
  },
];

const CHAR_PRODUCING_SPECIAL_BUTTONS: Record<string, string> = {
  "{space}": " ",
};

const CONTROL_BUTTONS = new Set([
  "{shift}",
  "{bksp}",
  "{numbers}",
  "{abc}",
  "{arrowleft}",
  "{arrowright}",
  "{clear}",
]);

export const getDisabledButtons = (
  layout: Record<string, readonly string[]>,
  allowedPattern: RegExp | null
): string => {
  if (!allowedPattern) {
    return "";
  }

  const disabled = new Set<string>();

  Object.values(layout).forEach((rows) => {
    rows.forEach((row) => {
      row.split(" ").forEach((token) => {
        if (!token || CONTROL_BUTTONS.has(token)) {
          return;
        }
        const char = CHAR_PRODUCING_SPECIAL_BUTTONS[token] ?? token;
        if (!allowedPattern.test(char)) {
          disabled.add(token);
        }
      });
    });
  });

  return Array.from(disabled).join(" ");
};
